module.exports = __webpack_public_path__ + "img/servers.382f614c.png";